import { FC, ReactNode, useState, useCallback } from 'react';
import {
  CampaignMetadataContext,
  CampaignMetadataContextValue,
  getDefaultCMSMetadata,
} from './CampaignMetadataContext';
import { CMSMetadata, DeviceFamily, Placement } from '@amzn/fire-tv-campaign-automation-service';
import { useSelection } from './SelectionContext';

interface CampaignMetadataContextProviderProps {
  children: ReactNode;
}

export const CampaignMetadataContextProvider: FC<CampaignMetadataContextProviderProps> = ({
  children,
}) => {
  const { deviceFamily, placement } = useSelection();
  const [metadata, setMetadata] = useState<CMSMetadata>(
    getDefaultCMSMetadata(
      deviceFamily ?? DeviceFamily.FIRE_TV,
      placement ?? Placement.FEATURE_ROTATOR,
    ),
  );

  const updateMetadata = useCallback((updates: Partial<CMSMetadata>) => {
    setMetadata((prev: CMSMetadata) => ({
      ...prev,
      ...updates,
    }));
  }, []);

  const contextValue: CampaignMetadataContextValue = {
    metadata,
    updateMetadata,
  };

  return (
    <CampaignMetadataContext.Provider value={contextValue}>
      {children}
    </CampaignMetadataContext.Provider>
  );
};
